import { element } from 'protractor';
import { Component, OnInit, NgZone } from '@angular/core';
import { ApiService } from 'src/app/services/api/api.service';
import { NavParams, ModalController, LoadingController } from '@ionic/angular';
import { BrickPreviewComponent } from '../brick-preview/brick-preview.component';
import { AuthService } from 'src/app/services/auth/auth.service';
import Swal from 'sweetalert2';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';

@Component({
    selector: 'app-order',
    templateUrl: './order.component.html',
    styleUrls: ['./order.component.scss'],
})
export class OrderComponent implements OnInit {
    // @ViewChild(IonContent, null) txtPhone: any;
    phone: any
    options = [];
    items: any
    order: any;
    amountSplit: any = 0
    
    constructor(
        public api: ApiService,
        public navParams: NavParams,
        public modalController: ModalController,
        private zone: NgZone,
        public auth: AuthService,
        public loadingCtrl: LoadingController,
        private router: Router,
        private http: HttpClient,
    ) {
        this.order = navParams.get('order');
        if (this.order.splits) {
            this.order.splits.forEach(element => {

                this.amountSplit += element.amount
                // console.log(element.amount)

                this.api.getDocument('accounts', element.friend).then(data => {
                    element.friend = data;
                })
            });
            // console.log("------------> this order");
            // console.log(this.order)
            // console.log(this.amountSplit)
        }

        if (this.order.scheduled) {
            this.order.schedule_time = this.order.schedule_time.toDate();
            this.order.schedule_date = this.order.schedule_date.toDate();
        }

        this.options.unshift();

        // recuperando informacion de los Colaboradores (delivery)
        this.api.getAllDocuments(`delivery`).then(data => {
            if (data) {
                data.forEach(element => {
                    if (element['countryCode'] == this.auth.countryCode) {

                        let arr = []
                        console.log(element)
                        arr['id'] = element.$key
                        arr['lastname'] = element.lastname
                        arr['name'] = element.name
                        arr['phonenumber'] = element.phonenumber

                        this.options.push(arr);
                    }

                });

            }
        })


    }

    onChange(evt) {
        console.log(typeof (this.options))
        console.log(evt)
        this.phone = evt

        // if (evt == -1) {
        //     this.items = this.options.map(x => x.id);
        // } else {
        //     let selectAllIndex = this.items.indexOf(-1);
        //     this.items.splice(selectAllIndex, 1);
        // }
    }

    changeCalled(type) {
        if (this.phone) {
            openInNewTab(type, this.phone, this.order.address.lat, this.order.address.lng)
        } else {
            Swal.fire(
                'Seleccione Datos de Delivery',
                'Registre en Menu -> Delivery. Los datos #CodigoPais + Telefono',
                'warning'
            )
        }
    }

    ngOnInit() { }

    ionViewWillEnter() {
        this.forceUpdate();
    }

    forceUpdate() {
        this.zone.run(() => {
            console.log('force update the screen');
        });
    }

    async seeBrick(brick) {

        const modal = await this.modalController.create({
            component: BrickPreviewComponent,
            cssClass: 'addModal',
            componentProps: {
                brick: brick.brick
            }
        });
        return await modal.present();
    }

    async loader() {
        return await this.loadingCtrl.create({
            spinner: 'lines-small',
            animated: true,
            mode: 'ios',
            translucent: false,
            cssClass: 'custom-class custom-loading',
        });
    }

    captureSplit(split) {
        this.loader().then(loader => {
            loader.present().then(() => {

                Swal.fire({
                    title: 'Esta seguro que deseas Aceptar la transferencia?',
                    text: "¡No podrás revertir esto!",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Si, estoy seguro'
                }).then((result) => {
                    if (result.value) {
                        let getData = `orderNo=split-${split.$key}&amount=${split.amount}&type=1`;
                        let url;

                        url = `https://payments.barlleno.app/transactionModification.php?${getData}`;

                        this.http.get(url)
                            .subscribe((response) => {
                                if (response['TransactionModificationResult']['ResponseCode'] == 1) {

                                    this.api.updateDocument('splits', split.$key, {
                                        'transaction_status': 'captured',
                                    }).then(data => {
                                        split.transaction_status = 'captured';
                                        Swal.fire(
                                            'Transacción Capturada',
                                            'Captura de fondos realizar con exito',
                                            'success'
                                        )
                                    })

                                    Swal.fire(
                                        'Transacción Capturada',
                                        'Captura de fondos realizar con exito',
                                        'success'
                                    )
                                } else {
                                    Swal.fire(
                                        'Error!',
                                        'No se pudo completar la captura de la transacción, comunicate con el equipo de barlleno',
                                        'error'
                                    )
                                }
                                loader.dismiss();
                            }, err => {
                                loader.dismiss();
                            });
                    } else {
                        loader.dismiss();
                    }
                });
            })
        })
    }

    capture(order) {
        const httpOptions = {
            headers: new HttpHeaders({
                'Authorization': 'Bearer prv_prod_PWw13Ai1yGYJuTF6BQJ99nG8w9MkTHAw'
            })
        };

        this.loader().then(loader => {
            loader.present().then(() => {
                Swal.fire({
                    title: 'Esta seguro que deseas Aceptar la transferencia?',
                    text: "¡No podrás revertir esto!",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Si, estoy seguro'
                }).then((result) => {

                    if (result.value) {
                        // let getData = `orderNo=${order.number}&amount=${order.total}&type=1`;
                        let getData = `orderNo=${order.number}&split-${order.$key}&amount=${order.total}&type=1`;
                        let transaction_id = order.transaction_id;
                        let url;
                        if (this.auth.countryCode == 'SV') {
                            url = `https://payments.barlleno.app/transactionModification.php?${getData}`;

                        } else if (this.auth.countryCode == 'GT') {
                            url = `https://payments.barlleno.app/gt/transactionModification.php?${getData}`;
                        } else if (this.auth.countryCode == 'CO') {
                            url = ((`https://production.wompi.co/v1/transactions/${transaction_id}`));
                        }

                        if (this.auth.countryCode !== 'CO') {
                            this.http.get(url)
                                .subscribe((response) => {
                                    if (response['TransactionModificationResult']['ResponseCode'] == 1) {
                                        this.api.updateDocument('orders', order.$key, {
                                            'transaction_status': 'captured',
                                            'status': 'making'
                                        }).then(data => {
                                            order.transaction_status = 'captured';
                                            Swal.fire(
                                                'Transacción Capturada',
                                                'Captura de fondos realizar con exito',
                                                'success'
                                            )
                                        })
                                    } else {
                                        Swal.fire(
                                            'Error!',
                                            'No se pudo completar la captura de transaccion, comunicate con el equipo de barlleno',
                                            'error'
                                        )
                                    }
                                    loader.dismiss();
                                    this.forceUpdate();
                                    this.router.navigate(['/monitor'])
                                }, err => {
                                    loader.dismiss();
                                });
                        }


                        else {
                            this.http.get(url, httpOptions)
                                .subscribe((response) => {
                                    if (response['data']['status'] == 'APPROVED') {
                                        this.api.updateDocument('orders', order.$key, {
                                            'transaction_status': 'captured',
                                            'status': 'making'
                                        }).then(data => {
                                            order.transaction_status = 'captured';
                                            Swal.fire(
                                                'Transacción Capturada',
                                                'Captura de fondos realizar con exito',
                                                'success'
                                            )
                                        })
                                    } else {
                                        Swal.fire(
                                            'Error!',
                                            'No se pudo completar la captura de transaccion, comunicate con el equipo de barlleno',
                                            'error'
                                        )
                                    }
                                    loader.dismiss();
                                }, err => {
                                    loader.dismiss();
                                });
                        }

                    } else {
                        loader.dismiss();
                    }
                });
            })
        })
    }

    revertSplit(split) {
        this.loader().then(loader => {
            loader.present().then(() => {
                Swal.fire({
                    title: 'Esta seguro que deseas Revertir la transferencia?',
                    text: "¡No podrás revertir esto!",
                    icon: 'error',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Si, estoy seguro'
                }).then((result) => {
                    if (result.value) {
                        let getData = `orderNo=split-${split.$key}&amount=${split.amount}&type=3`;
                        this.http.get(`https://payments.barlleno.app/transactionModification.php?${getData}`)
                            .subscribe((response) => {
                                if (response['TransactionModificationResult']['ResponseCode'] == 1) {
                                    this.api.updateDocument('splits', split.$key, {
                                        'transaction_status': 'Reverted',
                                    }).then(data => {
                                        split.transaction_status = 'Reverted';
                                        Swal.fire(
                                            'Transacción Capturada',
                                            'Captura de fondos realizar con exito',
                                            'success'
                                        )
                                    })
                                    Swal.fire(
                                        'Transacción Revertida',
                                        'Reversión de fondos realizar con exito',
                                        'success'
                                    )
                                } else {
                                    Swal.fire(
                                        'Error!',
                                        'No se pudo revertir la transacción, comunicate con el equipo de barlleno',
                                        'error'
                                    )
                                }
                                loader.dismiss();
                            }, err => {
                                loader.dismiss();
                            });
                    }
                    else {
                        loader.dismiss();
                    }
                })
            })
        })
    }

    captureOrder() {
        this.loader().then(loader => {
            loader.present().then(() => {

                Swal.fire({
                    title: 'Esta seguro que deseas Aceptar la transferencia?',
                    text: "¡No podrás revertir esto!",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Si, estoy seguro'
                }).then((result) => {
                    if (result.value) {
                        let getData = `orderNo=${this.order.number}&amount=${this.order.total}&type=1`;
                        let url;

                        url = `https://payments.barlleno.app/transactionModification.php?${getData}`;

                        this.http.get(url)
                            .subscribe((response) => {
                                if (response['TransactionModificationResult']['ResponseCode'] == 1) {
                                    this.api.updateDocument('orders', this.order.$key, {
                                        'transaction_status': 'captured',
                                        'status': 'making'
                                    }).then(data => {
                                        this.order.transaction_status = 'captured';
                                        Swal.fire(
                                            'Transacción Capturada',
                                            'Captura de fondos realizar con exito',
                                            'success'
                                        )
                                    })
                                } else {
                                    Swal.fire(
                                        'Error!',
                                        'No se pudo completar la captura de la transacción, comunicate con el equipo de barlleno',
                                        'error'
                                    )
                                }
                                loader.dismiss();
                            }, err => {
                                loader.dismiss();
                            });
                    } else {
                        loader.dismiss();
                    }
                });
            })
        })
    }

    revertOrder() {
        this.loader().then(loader => {
            loader.present().then(() => {
                Swal.fire({
                    title: 'Esta seguro que deseas Revertir la transferencia?',
                    text: "¡No podrás revertir esto!",
                    icon: 'error',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Si, estoy seguro'
                }).then((result) => {
                    if (result.value) {
                        let getData = `orderNo=${this.order.number}&amount=${this.order.total}&type=3`;
                        this.http.get(`https://payments.barlleno.app/transactionModification.php?${getData}`)
                            .subscribe((response) => {
                                if (response['TransactionModificationResult']['ResponseCode'] == 1) {
                                    this.api.updateDocument('orders', this.order.$key, {
                                        'transaction_status': 'Reverted',
                                        'status': 'canceled'

                                    }).then(data => {
                                        this.order.transaction_status = 'Reverted';
                                        Swal.fire(
                                            'Transacción Revertida',
                                            'Reversión de fondos realizar con exito',
                                            'success'
                                        )
                                    })
                                } else {
                                    Swal.fire(
                                        'Error!',
                                        'No se pudo revertir la transacción, comunicate con el equipo de barlleno',
                                        'error'
                                    )
                                }
                                loader.dismiss();
                            }, err => {
                                loader.dismiss();
                            });
                    }
                    else {
                        loader.dismiss();
                    }
                })
            })
        })
    }
}

function openInNewTab(type, phone, lat, lng) {
    if (type == 'google') {
        // google
        var win = window.open(`https://api.whatsapp.com/send?phone=${phone}&text=Hola,%20Esta%20es%20la%20localizacion%20del%20cliente%20%20https://www.google.com.ar/maps/place/${lat},${lng}`, '_blank');
        win.focus();
    } else {
        // waze
        // var win = window.open(`https://api.whatsapp.com/send?phone=${phone}&text=hola,%20Esta%20es%20la%20localizacion%20del%20clinte%20%20https://www.google.com.ar/maps/place/${lat},${lng}`, '_blank');
        var win = window.open(`https://api.whatsapp.com/send?phone=${phone}&text=Hola,%20Esta%20es%20la%20localizacion%20del%20cliente%20%20https://waze.com/ul?ll=${lat},${lng}&z=10`, '_blank');
        win.focus();
    }
}
